import React, { useState, useEffect } from 'react'
import { useSelector } from 'react-redux'
import AWS from 'aws-sdk'

// import CloseIcon from '@material-ui/icons/Close'

// import { makeStyles } from '@material-ui/core/styles'
import Button from '@material-ui/core/Button'
import Alert from '@material-ui/lab/Alert'
import Dialog from '@material-ui/core/Dialog'
import DialogActions from '@material-ui/core/DialogActions'
import DialogContent from '@material-ui/core/DialogContent'

import { Spin } from 'antd'
import { LoadingOutlined } from '@ant-design/icons'

import RpcApiClient from 'datasources/RpcApiClient'

import '../filesMenu.css'

function DeleteDialog(props) {
  const [dialogOption, setDialogOption] = useState('none')
  const [alerta, setAlerta] = useState({ bool: false, severity: '', message: '' })

  const authData = useSelector((state) => state.auth.authData)

  // useEffect(() => {
  //   console.log(props.selectedFile)
  // }, [])

  const deleteFile = () => {
    setDialogOption('loading')
    const body = {
      dynamo_key: { document_id: props.selectedFile.id },
      s3_key: props.selectedFile.key + '/' + props.selectedFile.id + '.geojson',
    }
    try {
      RpcApiClient.deleteGeocreatorFile(authData.jwtToken, body).then(() => {
        props.getFiles()
        setDialogOption('end')
        // setOpenDelete(false)
        setAlerta({ bool: true, severity: 'success', message: 'The project has been deleted.' })
      })
    } catch (err) {
      setDialogOption('end')
      setAlerta({ bool: true, severity: 'error', message: 'Something went wrong. Please try again.' })
    }
  }

  return (
    <Dialog
      open={props.openDelete}
      onClose={() => props.setOpenDelete(false)}
      style={{ fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif' }}
    >
      <div style={{ flex: '0 0 auto', margin: '0', padding: '16px 24px', fontSize: '14px' }}>
        <h3>
          Delete <b>{props.selectedFile.name}</b> project?
        </h3>
      </div>
      <DialogContent>
        {dialogOption === 'none' ? (
          <div style={{ flex: '1 1 auto', padding: '0px 24px', fontSize: '15px', color: '#9d9d9d' }}>
            If you delete this file, you delete it from your account and any other users registered in your company.
            Would you like to continue?
          </div>
        ) : dialogOption === 'loading' ? (
          <div style={{ height: '88px', width: '552px', display: 'grid' }}>
            <Spin
              style={{ margin: 'auto', alignSelf: 'center', color: '#03a9f4' }}
              tip="Loading..."
              size="large"
              indicator={<LoadingOutlined />}
            ></Spin>
          </div>
        ) : (
          <div
            style={{
              flex: '1 1 auto',
              padding: '0px 24px',
              fontSize: '15px',
              color: '#9d9d9d',
              width: '552px',
              display: 'grid',
              gap: '15px',
            }}
          >
            <Alert severity={alerta.severity}>{alerta.message}</Alert>
            <Button
              variant="outlined"
              size="small"
              style={{ width: '60px', margin: 'auto' }}
              onClick={() => {
                props.setOpenDelete(false)
                setDialogOption('none')
                // setAlerta({ bool: false, severity: '', message: '' })
              }}
            >
              Close
            </Button>
          </div>
        )}
      </DialogContent>
      <DialogActions>
        {dialogOption === 'none' ? (
          <div style={{ display: 'flex', gap: '15px', width: '150px', margin: 'auto', marginBottom: '10px' }}>
            <Button
              variant="outlined"
              color="secondary"
              size="small"
              style={{ color: 'red', borderColor: 'red' }}
              onClick={() => props.setOpenDelete(false)}
            >
              Cancel
            </Button>
            <Button
              variant="outlined"
              color="primary"
              size="small"
              style={{ color: '#03a9f4', borderColor: '#03a9f4' }}
              onClick={() => deleteFile()}
            >
              Delete
            </Button>
          </div>
        ) : null}
      </DialogActions>
    </Dialog>
  )
}

export default DeleteDialog
